import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getConsent } from "@/components/CookieBanner";

const CLARITY_PROJECT_ID = "xiguu6wo71";
const STORAGE_KEY = "dds_cookie_consent_v1";
// Routes exclues de Clarity (espace membre + auth). Toutes les autres pages
// publiques (home, blog, contact, mentions, CGV, réservation) restent trackées.
const EXCLUDED_PREFIXES = ["/app", "/login", "/mot-de-passe-oublie", "/reset-password"];
let injected = false;
let paused = false;

function isExcludedPath(pathname) {
  if (typeof pathname !== "string") return false;
  return EXCLUDED_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));
}

function injectClarity() {
  if (injected) return;
  if (typeof window === "undefined") return;
  injected = true;
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_PROJECT_ID);
}

function pauseClarity() {
  if (!injected || paused) return;
  if (typeof window === "undefined" || typeof window.clarity !== "function") return;
  try { window.clarity("stop"); paused = true; } catch { /* silent */ }
}

function resumeClarity() {
  if (!injected || !paused) return;
  if (typeof window === "undefined" || typeof window.clarity !== "function") return;
  try { window.clarity("start"); paused = false; } catch { /* silent */ }
}

/**
 * Loads Microsoft Clarity only:
 *  - if the user has consented to analytics cookies (via CookieBanner)
 *  - AND the current route is NOT part of the member area (/app/*)
 * If the visitor later navigates into /app/* → clarity('stop') is called;
 * if they navigate back to the public site → clarity('start') resumes tracking.
 */
export default function ClarityLoader() {
  const location = useLocation();

  useEffect(() => {
    const consented = getConsent().analytics === true;
    const excluded = isExcludedPath(location.pathname);

    if (consented && !excluded) {
      injectClarity();
      resumeClarity();
    } else if (excluded) {
      pauseClarity();
    }

    // If consent isn't given yet, watch for it (only if not on excluded path)
    if (!consented && !excluded) {
      const interval = setInterval(() => {
        if (getConsent().analytics === true) {
          injectClarity();
          clearInterval(interval);
        }
      }, 1500);
      return () => clearInterval(interval);
    }
  }, [location.pathname]);

  return null;
}
